var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn btn-purple",on:{"click":function($event){return _vm.removeFeatureImage()}}},[_vm._v("حذف عکس")])
}
var staticRenderFns = []

export { render, staticRenderFns }